import React from 'react';
import { TableCell, TableRow} from '@mui/material';
import Select from '@mui/material/Select';
import {OutlinedInput, MenuItem, Chip, Stack, TextField, Autocomplete, Checkbox} from '@mui/material';
import styled from 'styled-components';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const ButtonWrapper = styled.div`
  display: flex;
`


const BrandMasterEditable = ({k,row, editFormData, handleCancelClick,
   page, rowsPerPage, onChangeEditBrand, SubmitButton, assetmasters, editCategory}) =>{
    return( <>
        <TableRow key={k} name={row.Category}>
           <TableCell component="th" scope="row">
           {(page)*(rowsPerPage)+k+1}
           </TableCell>
           
           <TableCell  align="left">
            <TextField
                  id="outlined-basic"
                  size='small'
                  type="text"
                  name={`brandmaster${(page)*(rowsPerPage)+k}`}
                  onChange={(event) => onChangeEditBrand(event)}
                  label="Brand Master"
                  value={editFormData[`brandmaster${(page)*(rowsPerPage)+k}`]}
                  variant="outlined"
                  sx={{backgroundColor:"white", width:"300px", height:"40px"}}
                />         
          </TableCell>             

          <TableCell align="left">
            <Autocomplete
              multiple
              id="applicable-category-edit"
              size='small'
              options={assetmasters ? Object.values(assetmasters).map(x => x.Category).filter(Boolean).sort() : []}
              value={editFormData[`applicableCategory${(page)*(rowsPerPage)+k}`] || []}
              onChange={(event, newValue) => onChangeEditBrand(event, newValue, `applicableCategory${(page)*(rowsPerPage)+k}`)}
              disableCloseOnSelect
              getOptionLabel={(option) => option || ""}
              renderOption={(props, option, { selected }) => (
                <li {...props} style={{ fontSize: '1rem' }}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 0, marginLeft: -8 }}
                    checked={selected}
                  />
                  {option}
                </li>
              )}
              sx={{ width: 300, backgroundColor: "white" }}
              renderInput={(params) => (
                <TextField 
                  {...params} 
                  label="Select Applicable Categories" 
                  sx={{ background: "white", width: "100%" }} 
                />
              )}
            />
          </TableCell>

          <TableCell align="left">
            <ButtonWrapper>
              <SubmitButton type="submit">Save</SubmitButton>
              <SubmitButton type="button" onClick={(e)=>handleCancelClick(e,k)}>Cancel</SubmitButton>
            </ButtonWrapper>                              
            </TableCell>
          </TableRow>     
        </>         
    )
}

export default BrandMasterEditable;